"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionMode = void 0;
const react_1 = __importStar(require("react"));
const AccordionStateContext_1 = require("./AccordionStateContext");
var AccordionMode;
(function (AccordionMode) {
    AccordionMode["SINGLE"] = "single";
    AccordionMode["SINGLE_COLLAPSABLE"] = "single_collapsable";
    AccordionMode["MULTIPLE"] = "multiple";
})(AccordionMode || (exports.AccordionMode = AccordionMode = {}));
const ACCORDION_DEFAULT_MODE = AccordionMode.SINGLE;
const Accordion = ({ children, defaultActiveIndex, defaultActiveIndexes, mode = ACCORDION_DEFAULT_MODE, }) => {
    const internalState = (0, react_1.useState)((mode === AccordionMode.MULTIPLE && defaultActiveIndexes) || [
        defaultActiveIndex,
    ]);
    const externalState = (0, AccordionStateContext_1.useAccordionStateContext)();
    const [activeIndexes, setActiveIndexes] = externalState !== null && externalState !== void 0 ? externalState : internalState;
    const isIndexActive = (index) => {
        return activeIndexes.findIndex(item => item === index) > -1;
    };
    const addActiveIndex = (index) => {
        setActiveIndexes([...activeIndexes, index]);
    };
    const removeActiveIndex = (index) => {
        const modifiedActiveIndexes = [...activeIndexes];
        const i = modifiedActiveIndexes.findIndex(item => item === index);
        modifiedActiveIndexes.splice(i, 1);
        setActiveIndexes(modifiedActiveIndexes);
    };
    const setIndexState = (index, active) => {
        if (mode === AccordionMode.MULTIPLE) {
            active ? addActiveIndex(index) : removeActiveIndex(index);
        }
        else if (mode === AccordionMode.SINGLE) {
            setActiveIndexes([index]);
        }
        else if (mode === AccordionMode.SINGLE_COLLAPSABLE) {
            if (activeIndexes.findIndex(item => item === index) === -1) {
                setActiveIndexes([index]);
            }
            else {
                setActiveIndexes([]);
            }
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.map(children, (child, index) => {
        return (react_1.default.createElement(child.type, Object.assign({ key: index }, child.props, { index: index, active: isIndexActive(index), onOpen: () => {
                setIndexState(index, true);
                child.props.onOpen && child.props.onOpen();
            }, onClose: () => {
                setIndexState(index, false);
                child.props.onClose && child.props.onClose();
            } })));
    })));
};
exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map